<template>
  <v-card
    outlined
    data-testid="checklistCreation-tooltip-addItems"
    class="d-flex justify-center align-center rounded-lg"
  >
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <Button
          data-testid="checklistCreation-button-addItem"
          v-on="on"
          color="blueGrey"
          :disabled="disabled"
          icon="mdi-plus-circle-outline"
          @click="$emit('addItem')"
        />
      </template>
      {{ $t('checklist.add_item') }}
    </v-tooltip>
    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <Button
          data-testid="checklistCreation-button-addSeparator"
          v-on="on"
          color="blueGrey"
          icon="mdi-view-agenda-outline"
          :disabled="disabled"
          @click="$emit('addItem', 'separator')"
        />
      </template>
      {{ $t('checklist.add_separator') }}
    </v-tooltip>
  </v-card>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'ChecklistMenu',
  components: {
    Button,
  },
  props: {
    disabled: Boolean,
  },
}
</script>
<style lang="scss">
.buttons {
  opacity: 1 !important;
}
.buttons::before {
  background-color: white;
  opacity: 1 !important;
}
</style>
